import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import { Label } from './label';

const Textarea = React.forwardRef(
  ({ className, label, description, error, ...props }, ref) => {
    return (
      <div className="grid w-full gap-1.5">
        {label && <Label htmlFor={props.id || props.name}>{label}</Label>}
        <textarea
          className={cn(
            'flex min-h-[80px] w-full rounded-md border border-gray-200 bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-800 dark:placeholder:text-gray-400 dark:focus-visible:ring-primary',
            error && 'border-destructive text-destructive',
            className,
          )}
          ref={ref}
          {...props}
        />
        {description && !error && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
        {error && <p className="text-sm font-medium text-destructive">{error}</p>}
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';

Textarea.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export { Textarea };
